define('viewmodels/pages/cash/methods/neteller/AddNetellerDepositViewModel',['underscore', 'knockout'], function(_, ko) {

    function AddNetellerDepositViewModel(DepositAmountStep, formFields, depositPage, depositModel, Wizard) {

        var methodModel = depositModel.methodModel(),
            wizardModel;

        this.wizardModel = wizardModel = new Wizard({
            steps: [
                {
                    field: formFields.emailField( methodModel.account ),
                    label: depositPage.findFieldByName('neteller_number_or_email_label'),
                    smallInfo:
                        '<a class="open-external-account" target="_blank" href="{{ createAccountLink }}">' +
                        '    {{ createAccountText }}' +
                        '</a>',
                    createAccountLink: methodModel.createAccountLink,
                    createAccountText: depositPage.findFieldByName('neteller_open_account'),
                    type: 'basicfield'
                },
                new DepositAmountStep(depositModel),
                {
                    field: formFields.numberField( methodModel.secureId ),
                    label: depositPage.findFieldByName('neteller_secure_id_label'),
                    smallInfo: null,
                    type: 'basicfield'
                }
            ],
            onPayment: function(promise) {

                return promise.then(null, function(e) {

                    // if we have any errors that can be associated with fields then invalidate them and return to that step
                    if (e.hasError('neteller.accountNumber.invalid')) {

                        methodModel.account.invalidate('NOT_NETELLER_ACCOUNT');
                        wizardModel.returnToIncompleteStep();

                    } else if (e.hasError('neteller.secureId.invalid')) {

                        methodModel.secureId.invalidate('NOT_NETELLER_SECUREID');
                        wizardModel.returnToIncompleteStep();

                    } else {
                        throw e;
                    }

                });
            }
        });
    }

    AddNetellerDepositViewModel.prototype.getView = function() {
        return 'views/pages/cash/methods/wizardMethod.html';
    };

    return AddNetellerDepositViewModel;

});

